/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getBalances} from '../api'

 export const useQueryGetBalances = createReactQueryHook('getBalances', getBalances)
